export default class LoadingOverlay {
  show(element, message) {
    this.setMessage(message)
    this.getOverlay().classList.add('active')
    element.appendChild(this.getOverlay())
  }

  dismiss() {
    this.getOverlay().classList.remove('active')
  }

  setMessage(message) {
    this.getOverlay().querySelector('.loading-overlay-message').textContent = message
  }

  getOverlay() {
    if (!this.overlay) {
      this.overlay = document.createElement('div')
      this.overlay.classList.add('loading-overlay')
      this.overlay.innerHTML = `<div class="loading-overlay-icon"></div><div class="loading-overlay-message"></div>`
    }

    return this.overlay
  }
}